import React from 'react';
import cn from 'classnames';

import { Icons, SpinnerOverlay, Tooltip } from '@components/common';

import { useDownloadFile } from '@hooks/common/useDownloadFile';

import { ASSET_ICONS } from '@components/Map/Markers/constants';

import styles from './AssetLogo.module.scss';

interface IAssetLogoProps {
	openLogoModal: () => void;
	id?: string | null;
	description?: string;
}

const AssetLogo = ({
	openLogoModal,
	id,
}: IAssetLogoProps) => {
	const {
		downloadUrl,
		isLoadingDownloadURL,
	} = useDownloadFile({ id });

	return (
		<div className={styles.assetContainer}>
			<div
				className={cn(styles.asset, { [styles.withoutImage]: !downloadUrl })}
				onClick={openLogoModal}
			>
				{isLoadingDownloadURL && <SpinnerOverlay />}
				{downloadUrl
					? <div
						className={styles.img}
						style={{
							backgroundImage: `url(${downloadUrl})`,
						}}
					/>
					: <img
						alt='Upload icon'
						src={ASSET_ICONS.DEFAULT_ASSET}
					/>

				}
				<div className={styles.uploadIcon}>
					{Icons.uploadAvatarIcon()}
				</div>
			</div>
			<div className={styles.description}>
				Upload icon
				&nbsp;
				<Tooltip
					content={<div>
						<div>Recommended:</div>
						<div>Supported format: PNG</div>
						<div>The aspect ratio must be 1:1</div>
						<div>The dimensions should be maximum 75x75 px</div>
					</div>
					}>
					<div>{Icons.info()}</div>
				</Tooltip>
			</div>
		</div>
	);
};

export default AssetLogo;
